/**
 * function that validate if dni value is valid or not
 */
export const isValidRut = rut => {
  if (typeof rut !== 'string') {
    return false
  }
  const cRut = clearFormat(rut)
  const number = cRut.substring(0, cRut.length - 1)

  const minLength = 4
  if (cRut.length < minLength) {
    return false
  }

  const cDv = cRut.charAt(cRut.length - 1).toUpperCase()
  const nRut = parseInt(cRut.substr(0, cRut.length - 1))
  if (isNaN(nRut) || isNaN(number)) {
    return false
  }
  return computeDv(nRut).toString().toUpperCase() === cDv
}

/**
 * function that return verification digit from a RUT
 */
export const computeDv = rut => {
  let suma = 0
  let mul = 2
  if (typeof rut !== 'number') {
    return
  }
  rut = rut.toString()
  for (let i = rut.length - 1; i >= 0; i--) {
    suma = suma + rut.charAt(i) * mul
    mul = (mul + 1) % 8 || 2
  }
  switch (suma % 11) {
    case 1:
      return 'k'
    case 0:
      return 0
    default:
      return 11 - (suma % 11)
  }
}

/**
 * remove dots and middle dash from given RUT
 */
export const clearFormat = value => {
  if (value) return value.replace(/[.-]/g, '')
  else return ''
}
